import {BaseSchemaDataModel, BaseSchemaModel} from "./base-schema-model";
import {SCHEMA_TYPE} from "./consts";
import {QuestionSchemaModel} from "./question-schema-model";
import {EntityDescriptionFaqViewModel} from "../../../modules/entity-description-module/models/entity-description.faq.view-model";

export class FaqPageSchemaDataModel extends BaseSchemaDataModel {
  mainEntity: Array<EntityDescriptionFaqViewModel>;
}

export class FaqPageSchemaModel extends BaseSchemaModel {
  model: FaqPageSchemaDataModel;

  constructor(model: FaqPageSchemaModel) {
    super(SCHEMA_TYPE.faqPage);

    this.model = model;
  }

  get typeParams(): String {
    return this.type ? `,"@type":"${this.type}"` : ``;
  }

  get mainEntityParams(): String {
    return this.model.mainEntity ? `,"mainEntity":[${this.mainEntityToString()}]` : ``;
  }

  toString(): String {
    return `${this.contextParams}${this.typeParams}${this.mainEntityParams}}`;
  }

  mainEntityToString() {
    return this.model.mainEntity.map((item: EntityDescriptionFaqViewModel) => {
      const itemModel = {
        //eslint-disable-next-line
        question: item.question.toString().fromHtmlToText()?.replaceAll('\"', '\\"'),
        //eslint-disable-next-line
        answer: item.answer?.replaceAll('\"', '\\"'),
        ...item
      }

      return (new QuestionSchemaModel(itemModel)).toString()
    })
  }
}
